// Le vocabulaire de couleur d'un score, en UN seul endroit.
//
// POURQUOI CE FICHIER EXISTE. Les deux apps nommaient et découpaient les
// paliers différemment : le widget en 'good | mid | low' avec des seuils à
// 70/40, la console en 'hi | mid | lo' avec des seuils à 80/65. Même chiffre,
// deux couleurs — un 72/100 était vert dans l'extension et orange dans la
// console, pour la même offre et le même CV. Rien ne le signalait : chaque
// côté était cohérent avec lui-même.
//
// Les seuils retenus sont ceux de l'EXTENSION, qui fixe la marque (c'est elle
// que l'utilisateur voit tous les jours). La console s'y aligne.

export type ScoreTone = 'good' | 'mid' | 'low'

/** Vert ≥ 70, orange ≥ 40, rouge sinon. */
export function scoreTone(score: number): ScoreTone {
  return score >= 70 ? 'good' : score >= 40 ? 'mid' : 'low'
}
